import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { RouteUtil } from '@us/web/shared/utils';
import { selectTurnOnTheStoreChainLinkFeature } from '@us/web/shop/data-access';
import { map } from 'rxjs';

export const handleBranchesGuard: CanActivateFn = () => {
    const store = inject(Store);
    const navCtrl = inject(NavController);

    return store.select(selectTurnOnTheStoreChainLinkFeature).pipe(
        map(turnOnTheStoreChainLinkFeature => {
            if (turnOnTheStoreChainLinkFeature) {
                navCtrl.navigateRoot(RouteUtil.getShopsRouteUrl());
                return false;
            }

            return true;
        })
    );
};
